import { React, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import Axios from 'axios'
import swal from 'sweetalert';

export default function Form2() {
    const { register, handleSubmit, reset, formState, formState: { errors, isSubmitSuccessful } } = useForm({ name: '', email: '', phone: '', business: '', businessType: '', companyName: '', message: '' });
    const onSubmit = data => {
        // console.log(data);
        // alert(JSON.stringify(data))
        submitData(data);
    };
    console.log(errors);

    useEffect(() => {
        if (formState.isSubmitSuccessful) {
            reset({ name: '', email: '', phone: '', business: '', businessType: '', companyName: '', message: '' });
        }
    }, [formState, reset]);

    const submitData = async (data) => {
        console.log(data)
        try {
            const result = await Axios.post("http://localhost:8000/inquiry", data)
            if (result) {
                swal("Congratulations!", "Your response has submitted successfully! We will definitely contact you soon", "success");
            } else swal("OOPS Sorry!", "Something went wrong. Please try again later", "error");
        } catch (error) {
            console.log(error);
        }
    }

    return (
        <form method="POST" className="mt-5 container g-3 needs-validation" onSubmit={handleSubmit(onSubmit)}>
            <div className="row"
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-duration="1000">
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <input
                        type="text"
                        placeholder="Enter Name"
                        className="form-control shadow-none"
                        {...register("name", { required: true })}
                    />
                    {errors.name?.type === 'required' && <p className="error-text text-primary">Name is required</p>}
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <input
                        type="email"
                        placeholder="Enter Email"
                        className="form-control shadow-none"
                        {...register("email",
                            {
                                required: true,
                                pattern: /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
                            })
                        }
                    />
                    {errors.email?.type === 'required' && <p className="error-text text-primary">Email is required</p>}
                    {errors.email?.type === 'pattern' && <p className="error-text text-primary">Email is invalid</p>}
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <input
                        type="number"
                        placeholder="Enter Mobile Number"
                        className="form-control shadow-none"
                        {...register("phone",
                            {
                                required: true,
                                minLength: 10,
                                maxLength: 10,
                            })
                        }
                    />
                    {errors.phone?.type === 'required' && <p className="error-text text-primary">Mobile Number is required</p>}
                    {errors.phone?.type === 'minLength' && <p className="error-text text-primary">Should contains 10 digits</p>}
                    {errors.phone?.type === 'maxLength' && <p className="error-text text-primary">Should contains 10 digits</p>}
                </div>
            </div>
            <div className="row"
                data-aos="fade-down"
                data-aos-delay="200"
                data-aos-duration="1000">
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <select className="form-control form-select shadow-none" {...register("business", { required: true })}>
                        <option value="">Select Business</option>
                        <option value="New Business (Startup)">New Business (Startup)</option>
                        <option value="Existing Business">Existing Business</option>
                    </select>
                    {errors.business?.type === 'required' && <p className="error-text text-primary">Business is required</p>}
                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <input
                        type="text"
                        placeholder="Enter Business Type"
                        className="form-control shadow-none"
                        {...register("businessType", { required: true })}
                    />
                    {errors.businessType?.type === 'required' && <p className="error-text text-primary">Business Type is required</p>}

                </div>
                <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                    <input
                        type="text"
                        placeholder="Enter Comapny Name"
                        className="form-control shadow-none"
                        {...register("comapnyName", { required: true })}
                    />
                    {errors.comapnyName?.type === 'required' && <p className="error-text text-primary">Comapny Name is required</p>}
                </div>
            </div>
            <textarea className="form-control shadow-none" placeholder="Type your project requirement" {...register("message", {})} /><br />

            <button type="submit"
                // onClick={submitData}
                className="info-btn btn btn-outline-danger fw-bold border border-danger mb-0 px-4 mt-3 rounded-pill border-2"
                data-aos="zoom-in"
            >Submit</button>
        </form>
    );
}